// extracted by mini-css-extract-plugin
export default {"player-col":"CellClass_player-col__Ruxs-"};